import {
  CategorySuggestion,
  NewSuggestion,
  PageSuggestion,
  ProductSuggestion,
  ServiceSuggestion,
  SlicedSuggestions,
  Suggestion,
  Suggestions,
} from 'types/suggestions';

export type PreparedSuggestions = {
  slicedSuggestions: SlicedSuggestions | null;
  flatSuggestions: Suggestion[] | null;
  newSuggestions: boolean;
};

export const prepareSuggestions = (suggestions: Suggestions | null, value: string): PreparedSuggestions => {
  if (suggestions) {
    const newSuggestions = suggestions.newSuggestions || [];
    const hasNewSuggestions = !!newSuggestions && newSuggestions.length > 0;

    const productSuggestions = hasNewSuggestions ? newSuggestions : suggestions.products;
    const suggestionSlice = getSlicedSuggestions(
      productSuggestions,
      suggestions.services,
      suggestions.categories,
    );
    const defaultSuggestionsSlice = getDefaultSlicedSuggestions(productSuggestions, suggestions.categories);

    const resultForValue = {
      slicedSuggestions: suggestionSlice,
      flatSuggestions: [...suggestionSlice[0], ...suggestionSlice[3], ...suggestionSlice[1]],
      newSuggestions: hasNewSuggestions,
    };

    const resultForEmptyValue = {
      slicedSuggestions: defaultSuggestionsSlice,
      flatSuggestions: [
        ...defaultSuggestionsSlice[2],
        ...defaultSuggestionsSlice[0],
        ...defaultSuggestionsSlice[1],
      ],
      newSuggestions: hasNewSuggestions,
    };

    const result = value ? resultForValue : resultForEmptyValue;

    return result;
  }

  return {
    slicedSuggestions: null,
    flatSuggestions: null,
    newSuggestions: false,
  };
};

const MAX_SUGGESTIONS_NUMBER = 6;

export function getSlicedSuggestions(
  products: (ProductSuggestion | NewSuggestion)[],
  services: ServiceSuggestion[],
  categories: CategorySuggestion[],
): SlicedSuggestions {
  const slicedProducts =
    services.length <= MAX_SUGGESTIONS_NUMBER / 2
      ? products.slice(0, MAX_SUGGESTIONS_NUMBER - services.length)
      : products.slice(0, MAX_SUGGESTIONS_NUMBER / 2);
  const slicedServices =
    products.length <= MAX_SUGGESTIONS_NUMBER / 2
      ? services.slice(0, MAX_SUGGESTIONS_NUMBER - products.length)
      : services.slice(0, MAX_SUGGESTIONS_NUMBER / 2);
  const slicedCategories = categories.slice(0, MAX_SUGGESTIONS_NUMBER / 2);

  return [slicedProducts || [], slicedServices || [], [], slicedCategories || []];
}

export function getDefaultSlicedSuggestions(
  products: (ProductSuggestion | NewSuggestion)[],
  categories: CategorySuggestion[],
): SlicedSuggestions {
  const slicedProducts = products.slice(0, MAX_SUGGESTIONS_NUMBER);
  const slicedCategories = categories.slice(0, MAX_SUGGESTIONS_NUMBER);
  const defaultPages: PageSuggestion[] = [{ categoryUrl: '/promo/' }, { categoryUrl: '/uslugi/' }];
  return [slicedProducts, [], defaultPages, slicedCategories || []];
}
